import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CONTAINER_SHIPMENTS_VIEW_ID } from './view-id-constants';

export const ContainerShipments = {
  label: (
    <FormattedMessage
      defaultMessage='Container Shipments'
      description='Container Shipments tab that lives in the left nav under the End of Day section'
      id='SxAtlf'
    />
  ),

  id: CONTAINER_SHIPMENTS_VIEW_ID,
};
